import { Card } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
const StyledCard = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'customVariant' &&
        prop !== 'disableBackground' &&
        prop !== 'disableShadow' &&
        prop !== 'disableBorders'
})(({ theme, customVariant, disableBackground, disableShadow, disableBorders }) => {
    const styles = {
        borderRadius: '24px',
        // Respect disableShadow across all variants
        ...(disableShadow ? { boxShadow: 'none' } : {}),
        ...(disableBorders ? { border: 'none' } : {})
    };
    if (disableBackground) {
        // Force transparent instead of theme.palette.background.paper
        styles.backgroundColor = 'transparent';
        styles.backgroundImage = 'none'; // avoid any Paper backgrounds
        styles.backdropFilter = 'none'; // no blur without a bg
        return styles;
    }
    // Background-enabled variants
    if (customVariant === 'default') {
        styles.backgroundColor = theme.palette.background.default;
        styles.borderRadius = '24px';
        styles.border = `1px solid ${alpha(theme.palette.grey[500], 0.24)}`;
        styles.color = theme.palette.text.primary;
    }
    else if (customVariant === 'blue') {
        styles.backgroundColor = alpha('#25292D', 0.3);
    }
    else if (customVariant === 'light') {
        styles.backgroundColor = alpha('#919EAB', 0.08);
        styles.backdropFilter = 'blur(20px)';
        if (!disableShadow) {
            styles.boxShadow = '-1px 1px 1px rgba(196, 205, 213, 1)';
        }
    }
    else if (customVariant === 'gradient') {
        styles.borderRadius = '24px';
        styles.background = theme.palette.primary.gradient?.bold;
        styles.color = theme.palette.common.white;
        if (!disableShadow) {
            styles.boxShadow = '0px 8px 24px rgba(0, 180, 219, 0.3)';
        }
    }
    else if (customVariant === 'primary') {
        styles.backgroundColor = alpha(theme.palette.primary.main, 0.08);
        styles.color = theme.palette.text.primary;
        styles.backdropFilter = 'blur(20px)';
        if (!disableShadow) {
            styles.boxShadow = `-1px 1px 1px ${alpha(theme.palette.primary.main, 0.2)}`;
        }
        if (!disableBorders) {
            styles.border = `1px solid ${alpha(theme.palette.primary.main, 0.16)}`;
        }
    }
    else if (customVariant === 'grey') {
        styles.backgroundColor = theme.palette.grey[100];
        styles.color = theme.palette.text.primary;
        styles.backdropFilter = 'blur(20px)';
        if (!disableBorders) {
            styles.border = `1px solid ${theme.palette.common.grey20}`;
        }
    }
    else if (customVariant === 'secondary') {
        styles.backgroundColor = alpha(theme.palette.secondary.main, 0.08);
        styles.color = theme.palette.text.primary;
        styles.backdropFilter = 'blur(20px)';
        if (!disableShadow) {
            styles.boxShadow = `-1px 1px 1px ${alpha(theme.palette.secondary.main, 0.16)}`;
        }
        if (!disableBorders) {
            styles.border = `1px solid ${alpha(theme.palette.secondary.main, 0.16)}`;
        }
    }
    else if (customVariant === 'success') {
        styles.backgroundColor = alpha('#22C55E', 0.08);
        styles.color = theme.palette.text.primary;
        styles.backdropFilter = 'blur(20px)';
        if (!disableShadow) {
            styles.boxShadow = `-1px 1px 1px ${alpha('#22C55E', 0.16)}`;
        }
        if (!disableBorders) {
            styles.border = `1px solid ${alpha('#22C55E', 0.16)}`;
        }
    }
    return styles;
});
export default StyledCard;
